;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { requiredString } from '@qogita/validation/string'
import { z } from 'zod'

export const loginSchema = z.object({
  email: requiredString('Please enter your email address').email(
    'Please enter a valid email address',
  ),
  password: requiredString('Please enter your password'),
})

export type LoginSchema = z.infer<typeof loginSchema>
